export enum TransferTypes {
    GiveBalance, 
    TakeBalance
}